module.exports = __webpack_public_path__ + "img/logo-avatar_shenglianyun.b91d38ce.png";